import { Component } from '@angular/core';
import { FieldReviewDashboardService } from './field-review-dashboard.service';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-field-review-dashboard',
  templateUrl: './field-review-dashboard.component.html',
  styleUrl: './field-review-dashboard.component.scss'
})
export class FieldReviewDashboardComponent {
  fieldReviewData: any;
  loading: boolean = true;
  UserIp: any;
  email: any;
  filteredFieldReviewData: any[] = [];
  selectedUserEmail: string | null = null;
  selectedReviewerEmail: string | null = null;
  userEmailOptions: any[] = [];
  reviewerEmailOptions: any[] = [];
  statusOptions = [
    { label: 'Pending', value: 'pending' },
    { label: 'Reviewed', value: 'reviewed' }
  ];
  selectedStatus: string = 'pending';
  allUserEmails: any;
  allReviewerEmails: any;

  constructor(private FieldReviewDashboardService: FieldReviewDashboardService, public toastr: ToastrService,) { }

  ngOnInit() {
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.loadAllOptionsAndData();
  }

  // getFieldReviews() {
  //   this.FieldReviewDashboardService.getFieldReviewData(this.email).subscribe(
  //     (response: any) => {
  //       this.fieldReviewData = response.field_reviews;
  //       this.filterReviews();
  //       this.loading = false;
  //     },
  //     (error) => {
  //       console.error('Error fetching field reviews:', error);
  //       this.loading = false;
  //     }
  //   );
  // }

  loadAllOptionsAndData() {
    this.loading = true;

    const payload: any = {
      email: this.email,
      status: false, // Pending by default
      selected_usermail: null,
      selected_reviewermail: null
    };

    this.FieldReviewDashboardService.getFieldReviewData(payload).subscribe(
      (response: any) => {
        this.fieldReviewData = response.field_reviews;
        this.filteredFieldReviewData = this.fieldReviewData;

        this.allUserEmails = [...new Set(this.fieldReviewData.map(item => item.user_mail))];
        this.allReviewerEmails = [...new Set(this.fieldReviewData.map(item => item.reviewer_email))];

        this.userEmailOptions = [{ label: 'All', value: 'ALL' }, ...this.allUserEmails.map(email => ({ label: email, value: email }))];
        this.reviewerEmailOptions = [{ label: 'All', value: 'ALL' }, ...this.allReviewerEmails.map(email => ({ label: email, value: email }))];

        this.loading = false;
      },
      (error) => {
        console.error('Error fetching field reviews:', error);
        this.loading = false;
      }
    );
  }

  getFieldReviews() {
    this.loading = true;

    const payload: any = {
      email: this.email,
      status: this.selectedStatus === 'pending' ? false : true,
      selected_usermail: this.selectedUserEmail && this.selectedUserEmail !== 'ALL' ? this.selectedUserEmail : null,
      selected_reviewermail: this.selectedReviewerEmail && this.selectedReviewerEmail !== 'ALL' ? this.selectedReviewerEmail : null
    };

    this.FieldReviewDashboardService.getFieldReviewData(payload).subscribe(
      (response: any) => {
        this.fieldReviewData = response.field_reviews;
        this.filteredFieldReviewData = this.fieldReviewData; // API returns filtered data
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching field reviews:', error);
        this.loading = false;
      }
    );
  }

  onFilterChange() {
    this.getFieldReviews();
  }


  // filterReviews() {
  //   this.filteredFieldReviewData = this.fieldReviewData.filter(data => {
  //     return this.selectedStatus === 'pending' ? !data.review_status : data.review_status;
  //   });
  // }

  markAsReviewed(review: any) {
    if (review.review_status === 'Reviewed') {
      this.toastr.info('This review is already marked as reviewed.', 'Info');
      return;
    }

    console.log("review", review)

    const payload = {
      user_email: this.email,
      id: review.id,
      nda_number: review.nda_number,
      brand_name: review.brand_name,
      field: review.field
    };
    console.log('Sending payload:', payload);

    this.FieldReviewDashboardService.updateFieldReview(payload).subscribe(
      (response) => {
        review.review_status = 'Reviewed';
        this.onFilterChange();
        this.toastr.success('Review marked as reviewed!', 'Success');
      },
      (error) => {
        console.error('Error updating review status:', error);
        this.toastr.error('Failed to update review status. Try again.', 'Error');
      }
    );
  }

}
